export default __webpack_public_path__ + "static/media/GTA.e543b8b5.png";